import React, { useEffect, useState } from 'react';
import '../../CSS/cardStyles.css';
import { getTranslations } from '../../utils/CardTranslations';

const CardOpening = ({ data, openingStyle = 'Tingkap A', children, openingColor = '#f2f2f', onOpen, musicReady = true }) => {
  const t = getTranslations(data?.language);
  const [isOpen, setIsOpen] = useState(false);

  // Reset open state whenever openingStyle changes
  useEffect(() => {
    setIsOpen(false);
  }, [openingStyle]);

  const getStyleClass = () => {
    if (openingStyle === 'Tingkap B') return 'tingkap-b';
    if (openingStyle === 'Tingkap C') return 'tingkap-c';
    if (openingStyle === 'Tingkap D') return 'tingkap-d';
    return 'tingkap-a';
  };

  const handleOpen = () => {
    if (!musicReady) return; // block opening if music not ready
    setIsOpen(true);
    if (onOpen) onOpen(); // notify parent that card is opened
  };


  return (
    <div className={`card-wrapper ${getStyleClass()} ${isOpen ? 'open' : ''}`} style={{ width: "auto" }}>
      {/* Flaps */}
      {openingStyle === 'Tingkap B' ? (
        <>
          <div className="flap top-flap" style={{ backgroundColor: openingColor }} />
          <div className="flap bottom-flap" style={{ backgroundColor: openingColor }} />
        </>
      ) : openingStyle === 'Tingkap C' ? (
        <>
          <div className="curtain-half curtain-left" style={{ backgroundColor: openingColor }} />
          <div className="curtain-half curtain-right" style={{ backgroundColor: openingColor }} />
        </>
      ) : openingStyle === 'Tingkap D' ? (
        <>
          <div className="envelope-flap envelope-pocket" />
          <div className="envelope-top-wrapper">
            <div className="envelope-flap envelope-top" style={{ backgroundColor: openingColor }} />
          </div>
        </>
      ) : (
        <>
          <div className="flap left-flap" style={{ backgroundColor: openingColor }} />
          <div className="flap right-flap" style={{ backgroundColor: openingColor }} />
        </>
      )}

      {/* Buka Button */}
      {openingStyle === 'Tingkap D' ? (
        <div
          className={`envelope-seal ${isOpen ? 'open' : ''} ${!musicReady ? 'buka-loading' : 'buka-ready'}`}
          onClick={handleOpen}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => event.key === 'Enter' && handleOpen()}
          aria-label={t.openCardButton}
        >
          <img src="/card-backgrounds/wax-seal.png" alt="" />
          {!musicReady ? (
            <div className="buka-spinner" style={{ borderTopColor: '#fff' }} />
          ) : (
            <div className="envelope-seal-text">
              <span
                className="envelope-seal-names"
                style={{
                  fontFamily: data?.fontNamingOpenCardStyle,
                  fontSize: data?.openCardName
                    ? (data.openCardName.length > 20 ? "9px" : data.openCardName.length > 13 ? "10px" : "12px")
                    : (data?.coupleCount === 'dua' ? "9px" : "11px"),
                }}
              >
                {data?.openCardName ? (
                  data.openCardName.split(' & ').map((name, index) => (
                    <React.Fragment key={index}>
                      {index > 0 && <br />}
                      {name}
                    </React.Fragment>
                  ))
                ) : data?.coupleCount === 'dua' ? (
                  <>
                    {data?.greetingName?.replace(/ & /g, '/')}
                    <br />
                    <span style={{ fontSize: "0.85em", opacity: 0.8, display: "inline-block", padding: "1px 0" }}>&amp;</span>
                    <br />
                    {data?.greetingName2?.replace(/ & /g, '/')}
                  </>
                ) : (
                  (data?.greetingName || 'Adam & Hawa').split(' & ').map((name, index) => (
                    <React.Fragment key={index}>
                      {index > 0 && <br />}
                      {name}
                    </React.Fragment>
                  ))
                )}
              </span>
              <span className="envelope-seal-buka">{t.openCardButton}</span>
            </div>
          )}
        </div>
      ) : (
        !isOpen && (
          <div
            className={`buka-button ${!musicReady ? 'buka-loading' : 'buka-ready'}`}
            style={{ '--theme-colour': data.themeColour }}
            onClick={handleOpen}
          >
            {!musicReady ? (
              /* Loading spinner while music is loading */
              <div className="buka-spinner-container">
                <div className="buka-spinner" style={{ borderTopColor: data.themeColour || '#45c0c0' }} />
              </div>
            ) : (
              /* Ready state — show name and BUKA */
              <>
                <span
                  style={{
                    fontFamily: data.fontNamingOpenCardStyle,
                    fontSize: data.openCardName
                      ? (data.openCardName === data.openCardName.toUpperCase()
                        ? (data.openCardName.length > 20 ? "13px" : data.openCardName.length > 13 ? "15px" : "20px")
                        : (data.openCardName.length > 25 ? "14px" : data.openCardName.length > 13 ? "17px" : "24px"))
                      : (data.coupleCount === 'dua' ? "14px" : "20px"),
                    ...(!data.openCardName && data.greetingName?.length > 13 && data.coupleCount !== 'dua'
                      ? { fontSize: "15px" }
                      : {})
                  }}
                >
                  {data.openCardName ? (
                    data.openCardName.split(' & ').map((name, index) => (
                      <React.Fragment key={index}>
                        {index > 0 && <br />}
                        {name}
                      </React.Fragment>
                    ))
                  ) : data.coupleCount === 'dua' ? (
                    <>
                      {data.greetingName?.replace(/ & /g, '/')}
                      <br />
                      <span style={{ fontSize: "0.85em", opacity: 0.8, display: "inline-block", padding: "2px 0" }}>&amp;</span>
                      <br />
                      {data.greetingName2?.replace(/ & /g, '/')}
                    </>
                  ) : (
                    (data.greetingName || 'Adam & Hawa').split(' & ').map((name, index) => (
                      <React.Fragment key={index}>
                        {index > 0 && <br />}
                        {name}
                      </React.Fragment>
                    ))
                  )}
                </span>
                <div>{t.openCardButton}</div>
              </>
            )}
          </div>
        )
      )}

      {/* Card Content */}
      <div className="card-content">
        {children}
      </div>
    </div>
  );
};

export default CardOpening;
